module.exports = __webpack_public_path__ + "assets/img/jiachib_2013_1.76989973.jpg";